export const BASE_DOMAIN = "https://integrityapp.transparency.bg/"
// export const BASE_DOMAIN = "http://192.168.100.49:8080/"
// export const BASE_DOMAIN = "https://tibb.happycompany.ltd/"
export const RECAPTCHA_SITE_KEY = "6Ld5fCIdAAAAAHENPZPqSnVqpjKPodTUGhXuQSeI"
export const DATE_FORMAT = "dd.mm.yyyy HH:MM:ss"